import React, { useState } from 'react';

const BehavioralEditModal = ({ title, body, onClose, onSave, answer }) => {
  console.log(answer);
  const [inputText, setInputText] = useState(body);
  const [titleText, setTitleText] = useState(title);

  return (
    <div>
      <div
        id="hs-basic-modal"
        className="hs-overlay fixed top-0 left-0 z-80 w-full h-screen bg-black/80 flex items-center justify-center opacity-100 overflow-x-hidden transition-all overflow-y-auto pointer-events-auto"
        role="dialog"
        tabIndex="-1"
        aria-labelledby="hs-basic-modal-label"
      >
        <div className="sm:max-w-lg sm:w-full m-3 sm:mx-auto">
          <div className="flex flex-col bg-white border shadow-xs rounded-xl pointer-events-auto">
            <div className="p-4 overflow-y-auto flex flex-col gap-2">
              {/* Label for Question */}
              <label className="text-sm font-medium text-black-700 ml-1">Question</label>
              <label className="text-sm font-medium text-gray-500 ml-1">
                Ex: Tell me about a time when you faced conflict on a team.
              </label>
              <input
                type="text"
                className="w-full p-2 border border-gray-300 rounded-lg text-gray-800 focus:outline-hidden focus:ring-2 focus:ring-blue-500"
                placeholder="Tell me about a time when..."
                value={titleText}
                onChange={(e) => setTitleText(e.target.value)}
              />

              {/* Label for Answer */}
              <label className="text-sm font-medium text-black-700 ml-1 mt-2">Answer</label>
              <label className="text-sm font-medium text-gray-500 ml-1">
                Ex: In my internship at Apple two years ago, I was working on.. .
              </label>
              <textarea
                className="h-auto w-full p-2 border border-gray-300 rounded-lg text-gray-800 focus:outline-hidden focus:ring-2 focus:ring-blue-500"
                placeholder="Answer with the STAR or CARL method!"
                value={inputText}
                onChange={(e) => setInputText(e.target.value)}
              />
            </div>

            <div className="flex justify-end items-center gap-x-2 py-3 px-4 border-t">
              <button
                onClick={onClose}
                type="button"
                className="py-2 px-3 inline-flex items-center gap-x-2 text-sm font-medium rounded-lg border border-gray-200 bg-white text-gray-800 shadow-xs hover:bg-gray-50 focus:outline-hidden focus:bg-gray-50 disabled:opacity-50 disabled:pointer-events-none"
              >
                Close
              </button>
              <button
                onClick={() => {
                  onSave(answer?.answer_id, inputText, titleText);
                  onClose();
                }}
                type="button"
                className="py-2 px-3 inline-flex items-center gap-x-2 text-sm font-medium rounded-lg border border-transparent bg-blue-600 text-white hover:bg-blue-700 focus:outline-hidden focus:bg-blue-700 disabled:opacity-50 disabled:pointer-events-none"
              >
                Save changes
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BehavioralEditModal;
